import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Services } from './components/Services';
import { Leadership } from './components/Leadership';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-pearl flex flex-col font-montserrat w-full overflow-x-hidden" data-id="element-0">
      <Navbar data-id="element-1" />

      <main className="flex-grow w-full" data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustBar data-id="element-4" />
        <WhyChooseUs data-id="element-5" />
        <Services data-id="element-6" />
        <Leadership data-id="element-7" />
        <FinalCTA data-id="element-8" />
      </main>

      <Footer data-id="element-9" />
    </div>;
}